/* eslint-disable react/prop-types */
import React from 'react';
import MdIcon from '~/shared/components/mdIcon';

import {
  EstablishmentContainer,
  Title,
  ContentBox,
  TopContainer,
  SubTitle,
  SubTitleContainer,
  Field,
  FieldContainer,
  FieldBox,
  ButtonIcon,
} from './styles';

const EstablishmentBox = ({
  title,
  subTitle,
  iconSubTitle,
  icon,
  colorSubTitle,
  color,
  setModalOpen,
}) => {
  return (
    <EstablishmentContainer>
      <Title>{title}</Title>
      <ContentBox>
        <TopContainer>
          <SubTitleContainer>
            <MdIcon size={0.9} icon={iconSubTitle} color={colorSubTitle} />
            <SubTitle>{subTitle}</SubTitle>
          </SubTitleContainer>
          <ButtonIcon onClick={() => setModalOpen()}>
            <MdIcon size={0.9} icon={icon} color={color} />
          </ButtonIcon>
        </TopContainer>
        <FieldBox>
          <FieldContainer>
            <Field>
              CNES: <strong>123.456.789.101.234</strong>
            </Field>
            <Field>
              E-mail: <strong>drograria.avenida@email.com</strong>
            </Field>
            <Field>
              Endereço:{' '}
              <strong>Avenida Monteiro Lobato, 2015, São Paulo - SP</strong>
            </Field>
          </FieldContainer>
          <FieldContainer>
            <Field>
              CNPJ: <strong>20.99902/0001</strong>
            </Field>
            <Field>
              Telefone: <strong>(11) 98765-4321</strong>
            </Field>
          </FieldContainer>
        </FieldBox>
      </ContentBox>
    </EstablishmentContainer>
  );
};

export default EstablishmentBox;
